// extracted by mini-css-extract-plugin
export var blue = "_3q-g";
export var brand = "_3q-c";
export var darkGrey = "_3q-f";
export var disabled = "_3q-6";
export var disabledSubtle = "_3q-7";
export var error = "_3q-8";
export var green = "_3q-h";
export var grey = "_3q-e";
export var icon = "_3q-0";
export var inherit = "_3q-b";
export var lightGrey = "_3q-d";
export var orange = "_3q-j";
export var pink = "_3q-l";
export var primary = "_3q-1";
export var purple = "_3q-m";
export var quaternary = "_3q-4";
export var quinary = "_3q-5";
export var red = "_3q-k";
export var secondary = "_3q-2";
export var success = "_3q-a";
export var tertiary = "_3q-3";
export var warning = "_3q-9";
export var white = "_3q-n";
export var yellow = "_3q-i";